import { render, staticRenderFns } from "./TrendGoalComponent.vue?vue&type=template&id=47ca9e24&scoped=true&"
import script from "./TrendGoalComponent.vue?vue&type=script&lang=js&"
export * from "./TrendGoalComponent.vue?vue&type=script&lang=js&"
import style0 from "./TrendGoalComponent.vue?vue&type=style&index=0&id=47ca9e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ca9e24",
  null
  
)

export default component.exports